// extracted by mini-css-extract-plugin
module.exports = {"postTitle":"post-module--postTitle--1PQex","date":"post-module--date--1iRWs","inner":"post-module--inner--1Xa_k"};